import EmptyState from '../../../../components/empty-state';
import Loading from '../../../../components/loading';
import { AdminClerksState } from '../hooks/use-admin-clerks';
import AdminClerkDisplay from './admin-clerks-display';

type AdminClerksListProps = {
	state: AdminClerksState;
}

const AdminClerksList = (props: AdminClerksListProps) => {
	const adminClerksState: AdminClerksState = props.state;
	const columnTitles = [
		"",
		"Account Email",
		"Name",
		"County",
		"Municipality",
		"State",
		"# of Charts",
		"Actions",
	];

	return (
		<div className="flex flex-col w-full">
			{adminClerksState.loading && <Loading />}
			{!adminClerksState.loading && (
				<div className="flex flex-col w-full px-12 pb-36">
					{adminClerksState.clerks.length > 0 && (
						<div
							className="w-full mb-8"
						>
							<div className="grid w-full grid-cols-8 grid-rows-1 p-3 font-medium text-left uppercase bg-white border font-poppins">
								{columnTitles.map((title, _index) => (
									<p key={_index}>{title}</p>
								))}
							</div>
							{adminClerksState.clerks.map((c, i: number) => {
								return (
									<div key={`clerk-${c.id}`}>
										<AdminClerkDisplay
											clerk={c}
											deleteClerk={adminClerksState.deleteClerk}
											editClerk={adminClerksState.editClerk}
											downloadCharts={adminClerksState.downloadCharts}
											printCharts={adminClerksState.printCharts}
											promoteClerk={adminClerksState.promoteClerk}
											removeClerkFromAdminRole={adminClerksState.removeClerkFromAdminRole}
											resetPassword={adminClerksState.resetPassword}
											backgroundColor={
												i % 2 === 0
													? "bg-secondary-lightblue"
													: "bg-white"
											}
											markChartsAsPrinted={adminClerksState.markChartsAsPrinted}
										/>
									</div>
								);
							})}
						</div>
					)}
					{adminClerksState.clerks.length === 0 && (
						<div className="w-full col-span-3">
							<EmptyState>No Clerks Found</EmptyState>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default AdminClerksList;
